import { reactive } from 'vue'
import Api from '../api/Notification'

const state = reactive({
    loading: false,
    notifications: [],
})

function init() {
    state.loading = true;
    return Api.Get().then(res => {
        state.loading = false;
        state.notifications = res.data.notifications;
    })
}

function isLoading() {
    return state.loading;
}

function getNotifications() {
    return state.notifications;
}

export default {
    state,
    init,
    isLoading,
    getNotifications
}
